"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { RegionalPageBottomLink } from "./RegionalPageBottomLink";

export function RegionalPageBottomLinks({
  children = "",
  title = "Amenities",
}) {
  return (
    <Block className={"section_amenities"} tag={"div"}>
      <Block className={"margin-bottom margin-medium"} tag={"div"}>
        <Block className={"heading-style-h6 text-color-blue"} tag={"div"}>
          {title}
        </Block>
      </Block>
      <Block className={"links-slot"} tag={"div"}>
        {children ?? (
          <>
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
            <RegionalPageBottomLink />
          </>
        )}
      </Block>
    </Block>
  );
}
